<template>
    <div>
        <el-select :size="size" clearable :value="value" placeholder="请选择用户类型" @change="getUsertype" style="width: 100%;">
            <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value" >
            </el-option>
        </el-select>
    </div>
</template>

<script>
import {dictDataList} from '@/api/dict'
export default {
    name: '',
    data() {
        return {
            // value1: this.value,
            // placeholder: this.placeholde,
            options: [
            {
                value: 2,
                label: '终端用户'
            }, {
                value: 1,
                label: '系统用户'
            }]
        }
    },
    props: {
        value: {
            default: '2'
        },
        size:{
            default:'normal'
        }
    },
    methods: {
        getUsertype(val) {
            console.log("methods触发了用户类型选择。。。" + val)
            this.$emit('updateUsertype', val)
        },
        init() {
            let data={type: 'sys_user_type'}
            dictDataList(data).then(response => {
                if (response.code != 200){
                    return this.$message.error(response.msg)
                }else{
                    this.options = response.data //.records
                    console.log(this.options)
                }
            })
        }
    },
    created() {
        this.init()
    }
}
</script>

<style scoped>

</style>
